import React from 'react';
export function HeroSection() {
  return <section id="hero-section" className="relative w-full flex flex-col text-center px-4 pt-6 pb-8 sm:pt-12 sm:pb-20 items-center justify-center overflow-hidden" style={{
    background: 'radial-gradient(ellipse at top, #F1F5F9 0%, #E2E8F0 60%, #DBEAFE 100%)'
  }} data-id="element-229">
      <div className="absolute top-10 left-1/4 w-[380px] h-[380px] rounded-full blur-[90px] pointer-events-none hidden sm:block" style={{
      background: 'rgba(30, 64, 175, 0.2)'
    }} data-id="element-230"></div>
      <div className="absolute bottom-10 right-1/4 w-[340px] h-[340px] rounded-full blur-[90px] pointer-events-none hidden sm:block" style={{
      background: 'rgba(251, 191, 36, 0.2)'
    }} data-id="element-231"></div>

      {/* Attention Badge */}
      <div className="relative bg-white border border-[#DBEAFE] text-[#DC2626] font-bold text-[10px] sm:text-xs px-3 py-1 sm:px-4 sm:py-1.5 rounded-full mb-4 sm:mb-6 flex items-center gap-1.5 sm:gap-2 shadow-sm" data-id="element-232">
        <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-[#DC2626] animate-pulse" data-id="element-233"></span>
        <span className="hidden sm:inline" data-id="element-234">
          🏐 PARA ENTRENADORES DE VÓLEY CANSADOS DE IMPROVISAR CADA SEMANA
        </span>
        <span className="sm:hidden" data-id="element-235">PARA ENTRENADORES DE VÓLEY</span>
      </div>

      {/* Main headline */}
      <h1 className="relative font-black max-w-6xl text-[38px] leading-[1.05] sm:text-7xl md:text-8xl sm:leading-[1.02] mb-4 sm:mb-6 tracking-tight" style={{
      color: '#0F172A'
    }} data-id="element-236">
        Todo tu año de{' '}
        <span style={{
        color: '#1E40AF'
      }} data-id="element-237">
          Voleibol resuelto.
        </span>
      </h1>

      {/* Subheadline */}
      <p className="relative text-sm sm:text-xl font-medium leading-relaxed mb-4 sm:mb-8 max-w-3xl mx-auto sm:bg-white/60 sm:backdrop-blur-sm sm:border sm:border-[#E2E8F0] sm:border-l-4 sm:px-8 sm:py-5 sm:rounded-r-xl sm:text-left sm:shadow-sm" style={{
      color: '#475569',
      borderLeftColor: '#1E40AF'
    }} data-id="element-238">
        <span className="font-bold" style={{
        color: '#1E40AF'
      }} data-id="element-239">
          MEGAPACK VOLEY LISTO
        </span>{' '}
        — El sistema "Abrir y Enseñar" con 6 tomos, más de 300 ejercicios y 6
        bonos exclusivos. Incluye ahora el nuevo KIT TÁCTICO PRO.{' '}
        <span className="hidden sm:inline font-semibold" style={{
        color: '#0F172A'
      }} data-id="element-240">
          Sin improvisar. Sin sacrificar tus fines de semana.
        </span>
      </p>

      {/* Mockup image */}
      <div className="relative w-full max-w-[300px] sm:max-w-[460px] md:max-w-[560px] mx-auto mb-4 sm:mb-8" data-id="element-241">
        <div className="absolute inset-0 blur-[50px] rounded-full hidden sm:block" style={{
        background: 'rgba(30, 64, 175, 0.15)'
      }} data-id="element-242"></div>
        <img src="https://cdn.magicpatterns.com/uploads/21HN2HYfpqG2TFW4P3yKUs/Diseno_sin_titulo_(64).webp" alt="MEGAPACK VOLEY LISTO — Kit Integral de Entrenamiento" className="relative w-full h-auto object-contain sm:drop-shadow-[0_20px_40px_rgba(30,64,175,0.15)]" width={500} height={500} fetchPriority="high" loading="eager" decoding="async" data-id="element-243" />
      </div>

      {/* Stars + Urgency */}
      <div className="relative flex flex-col items-center gap-2 mb-4 sm:mb-6" data-id="element-244">
        <div className="flex items-center gap-2" data-id="element-245">
          <span className="text-sm sm:text-lg" style={{
          color: '#FBBF24'
        }} data-id="element-246">
            ⭐⭐⭐⭐⭐
          </span>
          <span className="text-xs sm:text-base font-medium" style={{
          color: '#475569'
        }} data-id="element-247">
            4.9/5 · +800 reseñas verificadas
          </span>
        </div>
        <span className="font-bold text-xs sm:text-sm px-3 py-1 rounded-full border" style={{
        color: '#991B1B',
        backgroundColor: '#FEE2E2',
        borderColor: '#FECACA'
      }} data-id="element-248">
          🔥 62 entrenadores eligieron este Kit hoy
        </span>
      </div>

      {/* CTA Button */}
      <a href="#pricing" className="relative btn-primary-pulse font-black sm:text-2xl px-6 sm:px-12 py-4 sm:py-5 rounded-2xl transition-colors inline-block mb-3 sm:mb-4 w-full sm:w-auto max-w-xl text-white text-[18px] pt-[22px] pb-[22px] pl-[22px] pr-[22px]" style={{
      backgroundColor: '#008060'
    }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#006B4F'} onMouseLeave={e => e.currentTarget.style.backgroundColor = '#008060'} data-id="element-249">
        🚀 ¡SÍ, QUIERO EL MEGAPACK!
      </a>
    </section>;
}